<template>
  <b-container fluid>
    <b-row class="my-3">
      <b-col>
        <b-alert variant="danger" v-if="error" show><strong>Something went wrong!</strong> {{error}}</b-alert>

        <div v-if="sent">
          <b-alert variant="success" show><strong>Email has been sent.</strong> You may now close this panel.</b-alert>

          <b-button
            variant="outline-secondary"
            @click="close"
          >Close</b-button>
        </div>

        <b-card no-body v-else>
          <b-tabs card>
            <b-tab title="Preview" active>
              <template-editor
                :tools="['preview']"
                :show-resource-search="false"
              ></template-editor>
            </b-tab>

            <b-tab title="Edit">
              <template-editor
                :tools="['editor']"
              ></template-editor>
            </b-tab>
          </b-tabs>

          <template slot="footer" class="bg-white">
            <b-button
              variant="primary"
              @click="send"
            >Send</b-button>

            <b-button
              variant="outline-secondary"
              @click="close"
              class="ml-1"
            >Cancel</b-button>
          </template>
        </b-card>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TemplateEditor from '@/components/TemplateEditor'
import store from '@/store'

export default {
  components: {
    TemplateEditor
  },

  async beforeRouteEnter(to, from, next) {
    await store.dispatch('stages/fetchOne', to.params.id)

    // TODO: maybe make this an email action to reset everything
    const stage = store.state.stages.stage
    store.commit('emails/updateDocument', stage.template_document)
    store.commit('emails/updatePreviewHtml', stage.template_html)
    store.commit('emails/updateSubject', stage.email_subject)
    store.commit('emails/updatePreviewSubject', stage.email_subject)
    store.commit('emails/updateResource', {
      resourceType: to.params.resource_type,
      resourceId: to.params.resource_id
    })

    next()
  },

  computed: {
    ...mapState('emails', [
      'document',
      'subject',
      'resourceType',
      'resourceId'
    ]),

    ...mapState('stages', [
      'stage'
    ])
  },

  methods: {
    ...mapActions('stages', [
      'sendStageByEmail'
    ]),

    async send() {
      try {
        await this.sendStageByEmail({
          stageId: this.$route.params.id,
          resourceType: this.resourceType,
          resourceId: this.resourceId,
          subjectOverride: this.subject,
          bodyOverride: this.document.render()
        })
        this.sent = true
        // this.close()
      } catch (err) {
        console.error(err)
        this.error = `${err}`
      }
    },

    close() {
      parent.postMessage('remote-page-close', '*')
    }
  },

  data() {
    return {
      error: '',
      expandSections: ['body'],
      sent: false
    }
  }
}
</script>
